import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qaab_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export function getDeviceFingerprint() {
  let fp = localStorage.getItem("qaab_fp");
  if (!fp) {
    // basic stable fingerprint for MVP
    const raw = [
      navigator.userAgent,
      navigator.language,
      navigator.hardwareConcurrency || 0,
      `${screen.width}x${screen.height}`,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      Math.random().toString(36).slice(2),
    ].join("|");
    fp = btoa(unescape(encodeURIComponent(raw))).slice(0, 48);
    localStorage.setItem("qaab_fp", fp);
  }
  return fp;
}
